import script from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"

import "./HotkeyDoc.vue?vue&type=style&index=0&id=14222bf2&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14222bf2"]])

export default __exports__